import { ClosureCodesColumns } from "us.collection.admin/components/ClosureCodes/Constants"

export const INITIAL_ITEM_MENU = {
  visible: false,
  codeId: -1
};

export const COLUMNS = [
  {
    key: ClosureCodesColumns.MENU,
    title: "",
    width: "40px",
  },
  {
    key: ClosureCodesColumns.NAME,
    title: "US.COLLECTION.ADMIN:MANAGE_CLOSURE_CODES.NAME",
  },
  {
    key: ClosureCodesColumns.DISPLAY_NAME,
    title: "US.COLLECTION.ADMIN:MANAGE_CLOSURE_CODES.DISPLAY_NAME",
  },
  {
    key: ClosureCodesColumns.DESCRIPTION,
    title: "US.COLLECTION.ADMIN:MANAGE_CLOSURE_CODES.DISPLAY_NAME_ENGLISH",
  },
  {
    key: ClosureCodesColumns.ARCHIVE_IN,
    title: "US.COLLECTION.ADMIN:MANAGE_CLOSURE_CODES.ARCHIVE_IN",
    width: "130px",
  },
  {
    key: ClosureCodesColumns.DELETE_IN,
    title: "US.COLLECTION.ADMIN:MANAGE_CLOSURE_CODES.DELETE_IN",
    width: "130px",
  },
  {
    key: ClosureCodesColumns.ARCHIVE_FROM,
    title: "US.COLLECTION.ADMIN:MANAGE_CLOSURE_CODES.ARCHIVE_FROM",
    width: "170px",
  },
  {
    key: ClosureCodesColumns.BAD_DEBT_RECORD,
    title: "US.COLLECTION.ADMIN:MANAGE_CLOSURE_CODES.BAD_DEBT_RECORD",
    width: "170px",
  },
];